import {STORAGE_KEY, SETTINGS} from './const';
import {storageService} from 'services/storage';
import {getTodayStartTime, getCurrentTime, MILLISECONDS_IN_DAY} from 'shared/utils/dateTime';

const {maxDailyViews, maxTotalViews} = SETTINGS;

const readPromo = (): PromoMessage => storageService.getItem(STORAGE_KEY);
const savePromo = (promo: PromoMessage): void => storageService.setItem(STORAGE_KEY, promo);

const createPromo = (): PromoMessage => ({
  shownToday: 0,
  shownTotal: 0,
  registered: getTodayStartTime(),
  lastShown: getTodayStartTime(),
});

function canShowToday({shownToday, shownTotal}: PromoMessage): boolean {
  // Showing promo every other day
  const currentTime = getCurrentTime();
  const isOtherDay = currentTime % (2 * MILLISECONDS_IN_DAY) > MILLISECONDS_IN_DAY;

  return isOtherDay && shownToday < maxDailyViews && shownTotal < maxTotalViews;
}

function shownEarlier(promo: PromoMessage): boolean {
  return promo.lastShown < getTodayStartTime();
}

function showToday(promo: PromoMessage): PromoMessage {
  const shownToday = promo.shownToday + 1;
  const shownTotal = promo.shownTotal + 1;
  return {...promo, shownToday, shownTotal};
}

function propagate(promo: PromoMessage): PromoMessage {
  const shownToday = 0;
  const lastShown = getTodayStartTime();
  return {...promo, shownToday, lastShown};
}

function createService(): PromoMessageService {
  let isVisible = false;

  return {
    isVisible: () => isVisible,
    init() {
      let promo = readPromo() ?? createPromo();

      if (shownEarlier(promo)) promo = propagate(promo);
      if (canShowToday(promo)) {
        promo = showToday(promo);
        isVisible = true;
      }

      savePromo(promo);
    },
  };
}

export const promoService = createService();
